module.exports = __webpack_public_path__ + "img/albumcover01.be623455.jpg";